import { Description, Spinner } from '@repo/ui'

import { CardGridCategory } from '@/components/CardGridCategory'
import { useQuerySystemTriviaLists } from '@/pages/trivia-lists/queries/useQuerySystemTriviaLists'

interface SystemPlaylistsProps {
  onClick: (listId: string) => void
}

export function SystemTriviaLists({ onClick }: SystemPlaylistsProps) {
  const { data = [], isLoading } = useQuerySystemTriviaLists()

  if (isLoading) return <Spinner label='Loading our trivia lists...' />

  return (
    <CardGridCategory
      description={<Description>Try one of our suggested trivia lists.</Description>}
      handleClick={onClick}
      heading='Our Trivia Lists'
      items={data}
    />
  )
}
